export default __webpack_public_path__ + "static/media/LotActualQuantity.25d280d7.csv";